import { createAsyncThunk } from '@reduxjs/toolkit';
import { A as AddProductsToWishlist, R as RemoveProductsFromWishlist } from '../../RemoveProductsFromWishlist-WCaYiZlq.js';
import { c as privateMutate } from '../../requestsCollection-gritD79O.js';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/logToSlack.js';
import { getCookie } from '../../utils/cookies.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import { a as COOKIE_LANGUAGE_NAME } from '../../cookies-l-jEMp6P.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import 'lodash/cloneDeep';
import { d as dataLayerWishlist } from '../../wishlist-foOHzuD7.js';
import 'graphql-request';
import '../../services/auth/index.js';
import '../../utils/fetchPolicyLookup.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import 'cookies-next';
import '../../utils/isBot.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';

const addProductsToWishlist = createAsyncThunk('user/addProductsToWishlist', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig, siteConfig } = extra;
        const wishlist = await privateMutate(apolloConfig(), {
            mutation: AddProductsToWishlist,
            variables: payload,
        }).then(res => res.data.addProductsToWishlist.wishlist);
        const justAddedToWishlist = wishlist.items_v2.items.filter(item => item.product.sku === payload.wishlistItems[0].sku);
        const locale = getCookie(COOKIE_LANGUAGE_NAME);
        dataLayerWishlist(justAddedToWishlist, locale, siteConfig.productNameFilters);
        return wishlist;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const removeProductsFromWishlist = createAsyncThunk('user/removeProductsFromWishlist', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const wishlist = await privateMutate(apolloConfig(), {
            mutation: RemoveProductsFromWishlist,
            variables: payload,
        }).then(res => res.data.removeProductsFromWishlist.wishlist);
        return wishlist;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { addProductsToWishlist, removeProductsFromWishlist };
//# sourceMappingURL=thunks.js.map
